// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"empty-dashboard__wrapper--3FXBf","images":"empty-dashboard__images--MrCZC","pop":"empty-dashboard__pop--jMsvV"};